import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  class: "tickets-grid-wrapper"
};
var _hoisted_2 = {
  class: "tickets-grid"
};
var _hoisted_3 = {
  class: "grouping-letter"
};
var _hoisted_4 = {
  class: "product-group"
};

var _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", {
  class: "tickets-group-separator"
}, null, -1);

var _hoisted_6 = {
  ref: "loadTrigger"
};
var _hoisted_7 = {
  class: "product-group"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Card = _resolveComponent("Card");

  var _component_CardSkeleton = _resolveComponent("CardSkeleton");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keys, function (key) {
    return _openBlock(), _createElementBlock("div", {
      key: key
    }, [_createElementVNode("p", _hoisted_3, _toDisplayString(key), 1), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedProducts[key], function (card) {
      return _openBlock(), _createElementBlock("div", {
        key: card.productCategoryId,
        onTouchmove: _cache[0] || (_cache[0] = //@ts-ignore
        function () {
          return _ctx.handleScroll && _ctx.handleScroll.apply(_ctx, arguments);
        }),
        onTouchstart: _cache[1] || (_cache[1] = //@ts-ignore
        function () {
          return _ctx.handleTouchStart && _ctx.handleTouchStart.apply(_ctx, arguments);
        })
      }, [_createVNode(_component_Card, {
        didScroll: _ctx.didScroll,
        product: card
      }, null, 8, ["didScroll", "product"])], 32);
    }), 128))]), _hoisted_5]);
  }), 128)), _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_CardSkeleton), _createVNode(_component_CardSkeleton), _createVNode(_component_CardSkeleton), _createVNode(_component_CardSkeleton)])], 512), [[_vShow, !_ctx.noMoreProducts]])])]);
}